import React from "react";
import "./Yellow-Button.css";
import ReactLoading from "react-loading";

interface YellowButtonProps {
  label: string;
  onClick?: any;
  uppercase?: boolean;
  style?: any;
  disabled?: boolean;
  loading?: boolean;
}

const YellowButton = ({
  label,
  onClick,
  uppercase,
  style,
  disabled,
  loading,
}: YellowButtonProps) => {
  if (disabled) {
    return (
      <button
        className="gray-button"
        style={{ textTransform: uppercase ? "uppercase" : "none", ...style }}
      >
        {!loading && label}
      </button>
    );
  }

  if (onClick) {
    return (
      <button
        className="yellow-button"
        style={{ textTransform: uppercase ? "uppercase" : "none", ...style }}
        onClick={() => {
          onClick();
        }}
      >
        {!loading && label}
        {loading && (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <ReactLoading
              type={"balls"}
              color={"black"}
              height={30}
              width={30}
            />
          </div>
        )}
      </button>
    );
  } else {
    return (
      <button className="yellow-button" style={{}}>
        {label}
      </button>
    );
  }
};

export default YellowButton;
